var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ThemeProvider } from '@kareo/design-system';
import getDesignSystemTheme from 'shared-assets/lib/utils/getDesignSystemTheme';
import SavedCardList from './SavedCardList';
var SavedCardListWithTheme = function (props) {
    var dsTheme = getDesignSystemTheme();
    return (React.createElement(ThemeProvider, { theme: dsTheme },
        React.createElement(SavedCardList, __assign({}, props))));
};
export default SavedCardListWithTheme;
